/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './joinLink.defs.js'
export { main as default } from './joinLink.defs.js'
